export enum MeasurementType {
    containerWeight,
    containerProductBoxes,
    noMeasurementType = 99,
}
